import React from "react";
import { getSrcSet, getSizes, buildCmsUrl } from "../../utils/imageHelper";


import icon_seguridad from "../../assets/10_POSVENTA/01_Servicios exclusivos/Seguridad.svg";
import icon_confianza from "../../assets/10_POSVENTA/01_Servicios exclusivos/Confianza.svg";
import icon_eficiencia from "../../assets/10_POSVENTA/01_Servicios exclusivos/Eficiencia.svg";
import icon_comodidad from "../../assets/10_POSVENTA/01_Servicios exclusivos/Comodidad.svg";
import icon_conveniencia from "../../assets/10_POSVENTA/01_Servicios exclusivos/Conveniencia.svg";

/*eslint-disable */

interface PromesaComponentProps {
  data: any;
  benefits: any;
}

declare const window: any;
const PromesaComponent: React.FC<PromesaComponentProps> = ({data, benefits}) => {

  const [isVisible1, setIsVisible1] = React.useState(false);
  const [isVisible2, setIsVisible2] = React.useState(false);
  const ref1 = React.useRef<HTMLDivElement | null>(null);
  const ref2 = React.useRef<HTMLDivElement | null>(null);
  
  React.useEffect(() => {
    const observer1 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible1(true);
        } else if (entry.boundingClientRect.top > 0) {
          setIsVisible1(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref1.current) {
      observer1.observe(ref1.current);
    }

    const observer2 = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible2(true);
        } else if (entry.boundingClientRect.top > 0) {
          setIsVisible2(false);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref2.current) {
      observer2.observe(ref2.current);
    }

    return () => {
      if (ref1.current) {
        observer1.unobserve(ref1.current);
      }
      if (ref2.current) {
        observer2.unobserve(ref2.current);
      }
    };
  }, []);

  return (
    <div ref={ref1} className={`promesa-posventa-finanzas-container`}>
      {/* H2 - Título principal de finanzas */}
      <h2 className={`title-promesa-posventa-finanzas-container ${isVisible1 ? "visible" : ""}`}>
        {data.finance_title}
      </h2>
      
      {/* H3 - Descripción principal */}
      <h3 className={`text-promesa-posventa-finanzas-container ${isVisible1 ? "visible" : ""}`}>
        {data.finance_description}
      </h3>
      
      <div ref={ref2} className={`opciones-promesa-posventa-finanzas-container ${isVisible2 ? "visible" : ""}`}>
        {/* H3 - Título de beneficios */}
        <h3 className={`master-opcion-promesa-posventa-finanzas-container`}>
          {data.benefit_title}
        </h3>
        
        {benefits?.map((item: any, index: number) => (
          <div key={index} className={`opcion-promesa-posventa-finanzas-container ${isVisible2 ? `visible` : ""}`}>
            <img 
              src={buildCmsUrl(item?.media?.url)} 
              srcSet={getSrcSet(item?.media?.url || '')}
              sizes={getSizes('100px')}
              alt={`Icono de ${item.title}`} 
              className="icon-opcion-promesa-posventa-finanzas-container" 
            />

            {/* H4 - Título del beneficio */}
            <h4 className="title-opcion-promesa-posventa-finanzas-container">{item.title}</h4>
            {/* H5 - Descripción del beneficio */}
            <h5 className="text-opcion-promesa-posventa-finanzas-container">{item.description}</h5>
          </div>
        ))}
      </div>
      
      {/* BOTÓN SIN MODIFICAR */}
      <a 
        href={data.benefit_url} 
        target="_blank" 
        rel="noopener noreferrer"
        className={`link-promesa-posventa-finanzas-container ${isVisible2 ? "visible" : ""}`}
      >
        {data.benefit_url_text}
      </a>
    </div>
  );
};

export default PromesaComponent;